import { Components, Theme } from '@mui/material/styles';

export const flowInputAdornment: Components<Theme>['MuiInputAdornment'] = {
  styleOverrides: {
    root: {
      minWidth: '0',
      color: 'inherit',
      flexShrink: '0',
      width: '24px',
      marginLeft: '0',
      marginRight: '0',
      justifyContent: 'center',
      // change size of icon
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
      '&.MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
        marginTop: '0',
      },
      // contains icon button instead of just icon
      '&:has(.MuiIconButton-root)': {
        width: 'auto',
      },
    },
    positionStart: {
      marginRight: '8px',
    },
    positionEnd: {
      marginLeft: '4px',
    },
  },
};
